export type ISummaryController = ReturnType<typeof SummaryControllerFactory>;

export const SummaryControllerFactory = ({
  summaryService,
}: {
  summaryService: ISummaryService;
}) => {
  const getSummary: IGetSummaryController = async (payload) => {
    const response = await summaryService.getSummaryService(payload);
    return response;
  };

  return {
    getSummary,
  };
};
